import * as React from "react";
import { IconProps } from "storefront/ui/icons/types";

export const CaretRightIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        {...props}
        ref={forwardedRef}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.75 11.3107L8.96967 6.53033L10.0303 5.46967L15.25 10.6893V13.3107L10.0303 18.5303L8.96967 17.4697L13.75 12.6893V11.3107Z"
          fill={color}
        />
      </svg>
    );
  },
);

export default CaretRightIcon;
